import styled from "@emotion/styled";

export const AutocadUploadContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	h3: {
		...theme.project.typography.subtitle.subtitle1,
		color: theme.project.colors.fontColors.secondary,
		margin: 0
	},
	h6: {
		...theme.project.typography.heading.h6,
		color: theme.project.colors.fontColors.main,
		margin: 0
	}
}));

export const AutocadUploadContent = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: 8
});

export const AutocadUploadText = styled.div(({ theme }) => ({
	...theme.project.typography.body.body1,
	color: theme.project.colors.fontColors.main
}));

export const AutocadUploadTextBold = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	fontWeight: 500,
	color: theme.project.colors.fontColors.secondary
}));

export const AutocadUploadSubheader = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary,
	display: "flex"
}));
